import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Key, ReactNode } from 'react';

interface Customer {
    addresses: any;
    dateOfBirth: any;
    cityName: ReactNode;
    countryName: ReactNode;
    dietTypeName: any;
    allergenName: any;
    cuisineTypeName: any;
    addressLine1(addressLine1: any): unknown;
    id: Key | null | undefined;
    firstName: any,
    lastName: any,
    dob: any,
    genderId: any,
    phone: any,
    email: any,
    profileImageUrl: any,
    auditTrailId: any,
    isActive: boolean
}

interface CustomersState {
    data: Customer[];
    getByIdData: any;

    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_CUSTOMER_PORT;
const URL = import.meta.env.VITE_API_CUSTOMER_URL;
const PORTCUSTOMER = import.meta.env.VITE_USERS_PORT;
const URLCUSTOMER = import.meta.env.VITE_API_USERS_URL;

export const fetchCustomer = createAsyncThunk<Customer[], void, { rejectValue: string }>(
    'Customers/fetchCustomer',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: Customer[] }>('/get_all_customer', PORTCUSTOMER, URLCUSTOMER);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const getByIdCustomer = createAsyncThunk<Customer[],
    { id: any | string },
    { rejectValue: string }>(
        "customer/getByIdCustomer",

        async (params, { rejectWithValue }) => {
            try {
                const config = { params }
                const response = await apiService.get<any>('/get_by_id_customer', PORTCUSTOMER, URLCUSTOMER, config)
                return response.data

            } catch (error) {
                return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');


            }
        }
    )


export const createCustomer = createAsyncThunk<Customer, any, { rejectValue: string }>(
    'Customers/createCustomer',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: Customer }>('create_customer', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);


export const CustomerSlice = createSlice({
    name: 'Customers',
    initialState: {
        data: [],
        getByIdData: null,
        loading: false,
        error: null,
    } as CustomersState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCustomer.fulfilled, (state, action: PayloadAction<Customer[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchCustomer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })

            .addCase(getByIdCustomer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getByIdCustomer.fulfilled, (state, action) => {
                state.loading = false;
                state.getByIdData = action.payload;
            })
            .addCase(getByIdCustomer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to load cities';
            })

            .addCase(createCustomer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createCustomer.fulfilled, (state, action: PayloadAction<Customer>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createCustomer.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            });

    },

});

export default CustomerSlice.reducer;